/* eslint-disable */
import React, { useState } from "react";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Card,
  Group,
  ScrollArea,
  Table,
  Text,
  TextInput,
} from "@mantine/core";
import { IconEdit, IconEye, IconPlus, IconSearch } from "@tabler/icons-react";
import { useGetOrganizations } from "api/superAdmin/organizationManagement";
import ActionsBtn from "../../actionBtn/actionBtn";
import ModalOrgForm from "../../adminDashboard/components/modalForm/modalForm";
import { useGetUser } from "api/users/getUser";
// import ModalOrgForm from "./modalForm/modalForm";

export default function TableOrganiztion() {
  const { data: user } = useGetUser();
  const [page, setPage] = React.useState(1);
  const limit = 10;
  const [opened, setOpened] = useState(false);
  const handleClose = () => {
    setOpened(false);
  };
  const { data, isLoading, error } = useGetOrganizations(page, limit);
  const colors = ["#5c4bff", "#00b894", "#e17055"];
  const cols = ["purple", "green", "orange"];
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading organizations.</div>;

  return (
    <Card shadow="sm" radius="md" p="lg" mb={30}>
      <Group position="apart" mb="md">
        <Text weight={700}>Organizations Management</Text>
        <Group>
          <TextInput
            placeholder="Search organizations..."
            icon={<IconSearch size={16} />}
            radius="md"
          />
          <Button
            leftIcon={<IconPlus size={16} />}
            radius="md"
            color="violet"
            onClick={() => setOpened(true)}
          >
            Add Organization
          </Button>
        </Group>
      </Group>
      <ScrollArea>
        <Table verticalSpacing="md">
          <thead>
            <tr>
              <th>Organization</th>
              <th>Type</th>
              <th>Employees</th>
              <th>Projects</th>
              <th>Handbook</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.organizations.map((o, ind) => (
              <tr key={o.id} style={{ opacity: o.isDeleted ? 0.6 : 1 }}>
                <td>
                  <Group spacing="sm">
                    <Box
                      sx={{
                        backgroundColor: colors[ind % colors.length],
                        borderRadius: "8px",
                        padding: "8px 12px",
                      }}
                    >
                      <Text weight={700} color="white">
                        {o.name ? o.name.trim().charAt(0).toUpperCase() : ""}
                      </Text>
                    </Box>
                    <Box>
                      <Text fw={600}>{o.name}</Text>
                      <Text size="sm" c="dimmed">
                        {user?.email}
                      </Text>
                      {o.isDeleted && (
                        <Badge size="sm" color="red" mt={4}>
                          Deleted
                        </Badge>
                      )}
                    </Box>
                  </Group>
                </td>
                <td>{o.type}</td>
                <td>{o.employees}</td>
                <td>{o.projects}</td>
                <td>
                  {o.isDeleted ? (
                    <Text size="sm" color="dimmed">
                      -
                    </Text>
                  ) : o.handbook ? (
                    <Text
                      component="a"
                      href={o.handbook}
                      target="_blank"
                      rel="noopener noreferrer"
                      color="blue"
                      size="sm"
                      sx={{
                        maxWidth: 220,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "inline-block",
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                    >
                      View Handbook
                    </Text>
                  ) : (
                    <Text size="sm" color="dimmed">
                      -
                    </Text>
                  )}
                </td>

                <td>
                  {!o.isDeleted ? (
                    <ActionsBtn organization={o} />
                  ) : (
                    <Badge color="red" variant="light">
                      Deleted
                    </Badge>
                  )}
                  {/* <Group spacing="xs">
                    <ActionIcon variant="light" color="blue" title="View">
                      <IconEye size={16} />
                    </ActionIcon>
                    <ActionIcon variant="light" color="green" title="Edit">
                      <IconEdit size={16} />
                    </ActionIcon>
                    <ActionIcon variant="light" color="red" title="Suspend">
                      <IconEdit size={16} />
                    </ActionIcon>
                  </Group> */}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ScrollArea>
      <ModalOrgForm opened={opened} onClose={handleClose} />
    </Card>
  );
}
